import { DeviationData } from "to-be-removed/LocalData/Deviation/DeviationData";
import { LocalData } from "to-be-removed/LocalData/General/LocalData";
import { PropertyData } from "to-be-removed/LocalData/Property/PropertyData";

const hasTaskStatisticAccess = (deviation: DeviationData): boolean => {
  // Check if the user has access to the deviation
  if (!deviation.canViewDeviation()) return false;
  const property = deviation.parent instanceof PropertyData ? deviation.parent : undefined;
  if (!property) return false;

  return property.checkForLandlordRoles(LocalData.currentUser);
};

// Total Task hours
export const loadTotalTaskHours = async (deviation: DeviationData): Promise<void> => {
  if (!hasTaskStatisticAccess(deviation)) return;

  if (!deviation.costs.loaded) {
    await deviation.costs.loadWithPromise();
  }
};

export const getTotalTaskHours = (deviation: DeviationData): number => {
  if (!hasTaskStatisticAccess(deviation)) return 0;

  const hourRegistrations = deviation.costs.documents.filter((cost) => cost.costType === "timeEntry");
  const totalHours = hourRegistrations.reduce((total, cost) => {
    if (!cost.startDate || !cost.endDate) return total;
    return total + (cost.endDate.getTime() - cost.startDate.getTime());
  }, 0);
  const hours = totalHours / (1000 * 60 * 60); // Convert milliseconds to hours
  return Math.round(hours * 100) / 100;
};

export const calculateTotalTaskHours = async (deviation: DeviationData): Promise<number> => {
  if (!hasTaskStatisticAccess(deviation)) return Promise.resolve(0);

  if (!deviation.costs.loaded) {
    await deviation.costs.loadWithPromise();
  }
  return getTotalTaskHours(deviation);
};

// Total other task costs
export const loadTotalTaskCosts = async (deviation: DeviationData): Promise<void> => {
  if (!hasTaskStatisticAccess(deviation)) return;

  if (!deviation.costs.loaded) {
    await deviation.costs.loadWithPromise();
  }
};

export const getTotalTaskCosts = (deviation: DeviationData, includingVAT: boolean): number => {
  if (!hasTaskStatisticAccess(deviation)) return 0;

  const otherCosts = deviation.costs.documents.filter((cost) => cost.costType === "cost");
  const totalCosts = otherCosts.reduce((total, cost) => total + cost.calculateCost(includingVAT), 0);
  return Math.round(totalCosts * 100) / 100;
};

export const calculateTotalTaskCosts = async (deviation: DeviationData, includingVAT: boolean): Promise<number> => {
  if (!hasTaskStatisticAccess(deviation)) return Promise.resolve(0);

  if (!deviation.costs.loaded) {
    await deviation.costs.loadWithPromise();
  }
  return getTotalTaskCosts(deviation, includingVAT);
};

